//const CALLBACK_NAME = '__googleMapsApiOnLoadCallback__';
const GOOGLE_MAPS_URI = 'https://maps.googleapis.com/maps/api/js?';
let promise: Promise<undefined>;

export const CALLBACK_NAME = '__googleMapsApiOnLoadCallback__';

declare global {
	interface Window {
		[CALLBACK_NAME]?: () => void;
	}
};

type TAllowedMapsLibrary = 'places';

type TLoadGoogleMapsProps = {
	key: string;
	libraries: TAllowedMapsLibrary[]
}
export default ({key, libraries = []}: TLoadGoogleMapsProps) => {
	if (!promise) {
		promise = new Promise((resolve) => {
			const options = {
				key,
				v: '3',
				libraries,
				callback: CALLBACK_NAME
			};

			window[CALLBACK_NAME] = () => {
				resolve.call(null);
				delete window[CALLBACK_NAME];
			}

			const scriptElement = document.createElement('script');
			scriptElement.src = GOOGLE_MAPS_URI + Object.entries(options).map(([k, v]) => `${k}=${v}`).join('&');
			document.body.appendChild(scriptElement);
		});
	}

	return promise;
}
